export async function ImageUrlToFile(url, fileName) {
    const response = await fetch([url]);
    const blob = await response.blob();
    return new File([blob], fileName);
}